import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NotificationContainer } from 'react-notifications'

class App extends Component {
  render() {
    return (
      <div>
        {this.props.children}
        {/*<NotificationContainer />*/}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    userType: state.auth.userType,
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js